import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "context/AuthContext";
import { MainProvider } from "context/MainContext";
import { ThemeProvider } from "context/ThemeContext";
import TopBar from "layouts/top-bar/TopBar";
import Main from "layouts/Main";
import AppSidebar from "layouts/AppSidebar";
import AppRoutes from "core/AppRoutes";

const App = () => {
    return (
        <BrowserRouter>
            <ThemeProvider>
                <AuthProvider>
                    <TopBar />
                    <MainProvider>
                        <Main>
                            <AppSidebar />
                            <AppRoutes />
                        </Main>
                    </MainProvider>
                </AuthProvider>
            </ThemeProvider>
        </BrowserRouter>
    );
};
export default App;
